<template>
  <div id="history-content">
    <app-list
      listType="history"
      :records="data"
      :showHeaders="true"
      :displayColumns="displayColumns"
      :isListBusy="loading"
      :showSearch="false"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import moment from 'moment';

import List from './list';

export default {
  components: {
    'app-list': List
  },

  data () {
    return {
      loading: false,
      displayColumns: [
        {
          label: 'Date',
          value: 'date',
          width: '140px'
        },
        {
          label: 'User',
          value: 'coder'
        },
        {
          label: 'Action',
          value: 'action'
        }
      ],
      data: []
    }
  },

  methods: {
    ...mapActions({
      'getArticleHistory': 'analysisArticle/getArticleHistory'
    })
  },

  mounted () {
    this.loading = true;
    this.getArticleHistory({ projectId: this.$route.params.project_id, articleId: this.$route.params.article_id }).then(r => {
      const formattedData = (r.data?.data || []).map(dt => {

        let action = dt.type_op;
        if (dt.last_type_op === 'bulk-update') {
          action = 'bulk_update';
        }

        let actionText = `${this.$i18n.t('coding_history.type.' + dt.type)}${dt.name ? ' "' + dt.name + '" ' : ' '}${this.$i18n.t('coding_history.action.' + action)}`;

        if (dt.type_op === 'update' && dt.changes) {
          
          const changesText = dt.changes.map(ch => {
            const maxLength = 160;
            let change = ch.to;
            if (change.length > maxLength) {
              change = change.slice(0, maxLength - 3) + '...';
            }
            return `${this.$i18n.t('coding_history.compare_fields.' + ch.field)} set to "${change}"`;
          }).join(', ');

          actionText += ` - ${changesText}`;
        }

        return {
          date: dt.date && moment(dt.date).format('D MMM YYYY [at] HH:mm'),
          coder: dt.user,
          action: actionText
        }
      })
      this.data = [...this.data, ...formattedData];
      this.loading = false;
    }).catch(error => {
      this.loading = false;
    });
  }
}
</script>